<template>
  <section class="lora-info">
    <div class="lora-info__list">
      <div v-for="item in items" :key="item.uuid" class="lora-info__item">
        <LoraInfoTeaser :image="item.image" :title="item.title" :file="item.file" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  items: array
}>()
</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.lora-info {
  margin: var(--space--xxl) 0;

  &__list {
    @include tools.teasers-grid-item(3);
    row-gap: calc(var(--space--xxl));
    @include tools.to(xl) {
      @include tools.grid($columns: 2);
    }
    @include tools.to(s) {
      @include tools.grid($columns: 1);
    }
  }

  &__item {
    padding-left: 0;
  }
}
</style>
